@if (loaded) {
  @if (shouldContactSales$ | async) {
    <div
      class="no-price"
      >
      {{ 'FRONTEND.STORE.CONTACT_SALES' | translate }}
    </div>
  } @else {
    @if (isFree$ | async) {
      <div class="no-price">
        <b>{{ 'FRONTEND.STORE.FREE' | translate }}</b>
      </div>
    } @else {
      @if (!isAddon) {
        @if (hasVerifiedContract && billedProduct) {
          @for (tier of pricingTierData$ | async; track tier) {
            <div class="price-box">
              <span>
                @if (tier.isStartingPrice) {
                  <span class="starting-at">
                    {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
                  </span>
                }
                <b class="price-number">
                  {{ tier.priceStringForTierWithoutFreq }}
                </b>
              </span>
              <span
                class="tier-billing-freq"
                [ngClass]="{ 'va-wrap': wrapFrequency }"
                >
                {{ tier.pricingTierForProduct }}
              </span>
            </div>
          }
        } @else {
          @if (pricing?.prices) {
            @for (price of priceData$ | async; track price; let i = $index) {
              <div
                class="price-box"
                >
                <span>
                  @if (price.isStartingPrice) {
                    <span class="starting-at">
                      {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
                    </span>
                  }
                  <b class="price-number">
                    @if (i > 0) {
                      +
                    }
                    {{ price.priceStringForPricingWithoutFrequency }}
                  </b>
                  @if (
                    price.abbreviatedFrequencyString && useAbbreviatedFrequency
                    ) {
                    <span
                      class="billing-freq-abbrev"
                      [ngClass]="{ 'va-wrap': wrapFrequency }"
                      >
                      /{{ price.abbreviatedFrequencyString }}
                    </span>
                  }
                </span>
                @if (price.frequencyString && !useAbbreviatedFrequency) {
                  <span
                    class="billing-freq"
                    [ngClass]="{ 'va-wrap': wrapFrequency }"
                    >
                    {{ price.frequencyString }}
                  </span>
                }
              </div>
            }
          }
        }
      }
      @if (isAddon) {
        @if (hasVerifiedContract && billedProduct) {
          <div>
            @for (tier of pricingTierData$ | async; track tier) {
              <div class="price-box">
                <span class="addon-billing-freq">
                  {{ tier.pricingTierForAddon }}
                </span>
                <span>
                  @if (tier.isStartingPrice) {
                    <span class="starting-at">
                      {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
                    </span>
                  }
                  <b class="price-number">
                    {{ tier.priceStringForTier }}
                  </b>
                </span>
              </div>
            }
          </div>
        } @else {
          <div class="price-box">
            @if (pricing?.prices[0].frequency) {
              <span
                class="addon-billing-freq"
                >
                {{ (priceData$ | async)[0]?.frequencyString }}
              </span>
            }
            <span>
              @if (pricing?.prices[0]?.isStartingPrice) {
                <span
                  class="starting-at"
                  >
                  {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
                </span>
              }
              <b class="price-number">
                {{
                (priceData$ | async)[0]?.priceStringForPricingWithoutFrequency
                }}
              </b>
            </span>
          </div>
        }
      }
      @if (billedProduct && billedProduct.setupFee > 0) {
        <b
          class="price-box price-number"
          >
          + {{ billedProduct.setupFee | price$: billedProduct.currency | async }}
          {{ setupFeeString$ | async }}
        </b>
      }
      @if (
        billedProduct &&
        billedProduct.commitment &&
        billedProduct.commitment.initial > 1
        ) {
        <div
          class="commitment"
          >
          {{ commitmentMessage$ | async }}
        </div>
      }
    }
  }
} @else {
  <div class="stencil-pricing stencil-shimmer"></div>
}
